module.exports = "/_next/static/images/mugitoolive_front-22fb507552f98ffaf4724061a926b79b.jpg";